/**
 * Form interactions
 *
 * @since   1.0.0
 * @package veristream
 */
(function($) {
	// Hook for when elementor front end is loaded
	$( window ).on( 'elementor/frontend/init', function() {
	    //hook name is 'frontend/element_ready/{widget-name}.{skin}
	    //$scope is a jquery wrapped parent element
	    elementorFrontend.hooks.addAction( 'frontend/element_ready/section', function( $scope ){
	    	if ( $scope.hasClass('veristream-blue-bg') ) {
	    		// Do something if section has this class
	    	}
	    });
	 });

})(jQuery);
